import React, { PureComponent } from 'react';

/**
 * Components.
 */
import LandingSection from 'components/landing-section';
import LandingCard from 'components/landing-card';

/**
 * Style.
 */
import './third-section.scss';

class ThirdSection extends PureComponent {
  render() {
    const { reference } = this.props;

    return (
      <LandingSection className="third-section" reference={reference}>
        <div className="third-section-content-wrapper">
          <div className="third-section-content-header">Benefícios</div>
          <hr />
          <div className="third-section-content-sub-header">
            Através dos estudos Rosacruzes você poderá usufruir de inúmeros
            benefícios nos níveis físicos, psíquicos, emocionais e espirituais:
          </div>
          <div className="third-section-content">
            <LandingCard icon="thought" title="No Nível Físico">
              Aprenda a conseguir excelente saúde e aumentar a vitalidade. Goze
              de mais alegria na vida, adquirindo técnicas específicas para
              reduzir o estresse e intensificar os processos naturais de cura do
              seu corpo.
            </LandingCard>
            <LandingCard icon="mental" title="No Nível Mental">
              Aprenda como objetivar a vida que sonhou, quer se trate de
              felicidade e paz em sua experiência pessoal ou sucesso em seu
              trabalho. O estudo rosacruz lhe dará um conhecimento específico de
              metafísica, misticismo, psicologia, parapsicologia, filosofia e
              ciência. Aprenda técnicas para relaxação e meditação e como usar o
              recurso da visualização criativa para materializar imagens mentais
            </LandingCard>
            <LandingCard icon="intellectual" title="No Nível Emocional">
              Desenvolva um sentimento mais forte de confiança e paz, sabendo
              como recorrer à sua sabedoria interior, a fim de encontrar
              respostas para os desafios da vida. Essa paz interior vai lhe
              ajudar a permanecer calmo e concentrado em meio às crises; a ser
              uma fonte de fortalecimento para outrem; e a conseguir relações
              pessoais mais harmoniosas com seus amigos e entes queridos.
            </LandingCard>
            <LandingCard icon="meditation" title="No Nível Psíquico">
              Desperte seu sentido psíquico mais profundo, uma faculdade natural
              adormecida na maioria das pessoas e que só precisa ser
              desenvolvida. Aumente a força e o poder do seu Eu interior; leve-o
              a um padrão mais alto de atuação e abra um novo recurso à
              intuição, inspiração criativa e inovadoras soluções de problemas.
            </LandingCard>
            <LandingCard icon="famous" title="No Nível Espiritual">
              Realize um gradual despertar interior que o levará a uma
              permanente consciência da unidade de toda a Criação e de sua
              relação pessoal com o Todo. À partir dessa base espiritual tudo o
              mais vai fluir.
            </LandingCard>
          </div>
        </div>
      </LandingSection>
    );
  }
}

export default ThirdSection;
